class Header {

    constructor() {
        $(window).on('load', () => {
            return this.alignTextEventHandler();
        });

        $(window).resize(() => {
            return this.alignTextEventHandler();
        });

        $('body').on('fixHeights', () => {
            return this.alignTextEventHandler();
        });
    }

    alignTextEventHandler() {
        $('section.header [data-heightmatch]').css({
            'height': 'auto',
        });

        return $('section.header [data-heightmatch]').each((i, el) =>
            $(el).css({
                'height': `${ $('section.header [data-heightoriginal]').outerHeight() }px`,
            }),
        );
    }
}

export default Header;
